import React from "react";
import CardButton, { CardButtonProps } from "./CardButton";
import { ContentItem } from "../../constants/contentItems";

interface CardHeadingProps {
  label: ContentItem["label"];
  description?: ContentItem["description"];
  ctaText?: ContentItem["ctaText"];
  onCtaClick?: () => void;
  cardButtonColors?: CardButtonProps["colors"];
  ctaClassName?: string;
}

const CardHeading: React.FC<CardHeadingProps> = ({
  label,
  description,
  ctaText,
  ctaClassName,
  cardButtonColors,
  onCtaClick,
}) => {
  return (
    <div className="flex flex-col justify-start items-start">
      <div className="w-[27px] h-[4px] rounded-xl bg-white shadow-xl"></div>

      <h2 className="bebas-neue-font text-[34px] 1600px:text-[42px] 3440px:text-[52px] !font-[1000] bg-gradient-to-b from-[#FFFFFF] to-[#999999] bg-clip-text text-transparent leading-[1] mt-3">
        {label}
      </h2>

      {description && (
        <p className="text-white/50 text-[.75rem] 3440px:text-[1rem] 3440px:max-w-[350px] max-w-[270px] text-left">
          {description}
        </p>
      )}

      {ctaText && (
        <CardButton
          onClick={onCtaClick}
          className={`mt-14 ${ctaClassName}`}
          colors={cardButtonColors}
        >
          {ctaText}
        </CardButton>
      )}
    </div>
  );
};

export default CardHeading;
